import React from "react";
import CommentFilled from "./CommentFilled";
import CommentOutlined from "./CommentOutlined";

export default ({ commented }) => {
  return commented ? <CommentFilled /> : <CommentOutlined />;
};
